(() => {
  const filterForm = document.querySelector('[data-lab-filter-form]');
  if (filterForm) {
    const submit = () => {
      const url = new URL(filterForm.action || window.location.href, window.location.href);
      const formData = new FormData(filterForm);
      const next = new URLSearchParams();

      for (const [key, value] of formData.entries()) {
        if (String(value).trim() !== '') next.append(key, value);
      }

      url.search = next.toString();
      window.location.href = url.toString();
    };

    filterForm.addEventListener('change', (event) => {
      if (event.target.matches('input[type="checkbox"]')) submit();
    });
  }

  document.querySelectorAll('[data-lab-sort-form] select').forEach((select) => {
    select.addEventListener('change', () => select.form.submit());
  });

  document.querySelectorAll('[data-lab-localization-select]').forEach((select) => {
    select.addEventListener('change', () => select.form.submit());
  });

  document.querySelectorAll('[data-lab-studio-search]').forEach((input) => {
    const directory = input.closest('.lab-studios-directory');
    const cards = [...directory.querySelectorAll('[data-lab-studio-card]')];
    const emptyState = directory.querySelector('[data-lab-studio-empty]');
    const clearButton = directory.querySelector('[data-lab-studio-search-clear]');

    const filterStudios = () => {
      const query = input.value.trim().toLocaleLowerCase();
      let visible = 0;
      cards.forEach((card) => {
        const matches = !query || String(card.dataset.labStudioName || '').toLocaleLowerCase().includes(query);
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      if (emptyState) emptyState.hidden = visible !== 0;
    };

    input.addEventListener('input', filterStudios);
    clearButton?.addEventListener('click', () => {
      input.value = '';
      filterStudios();
      input.focus();
    });
  });

  document.querySelectorAll('[data-lab-home-grid]').forEach((grid) => {
    const home = grid.closest('.lab-home');
    const filterPanel = home?.querySelector('[data-lab-home-filter-panel]');
    if (!home || !filterPanel) return;

    let cards = [...grid.querySelectorAll('[data-lab-resource-card]')];
    const originalOrder = new Map(cards.map((card, index) => [card, index]));
    const filterButtons = [...filterPanel.querySelectorAll('[data-lab-home-filter]')];
    const priceForm = filterPanel.querySelector('[data-lab-home-price-form]');
    const minimumInput = filterPanel.querySelector('[data-lab-home-price-min]');
    const maximumInput = filterPanel.querySelector('[data-lab-home-price-max]');
    const minimumRange = filterPanel.querySelector('[data-lab-home-price-min-range]');
    const maximumRange = filterPanel.querySelector('[data-lab-home-price-max-range]');
    const priceFill = filterPanel.querySelector('[data-lab-home-price-fill]');
    const resetButton = filterPanel.querySelector('[data-lab-home-filter-reset]');
    const countLabel = home.querySelector('[data-lab-home-visible-count]');
    const emptyState = home.querySelector('[data-lab-home-filter-empty]');
    const sortSelect = home.querySelector('[data-lab-home-sort]');
    const categoryLinks = [...home.querySelectorAll('[data-lab-home-category]')];
    const frameworkLinks = [...home.querySelectorAll('[data-lab-framework-card]')];
    let loadMoreButton = home.querySelector('[data-lab-home-load-more]');

    const normalize = (value) => String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

    const aliases = new Map([
      ['mlos', 'mlo'],
      ['scripts', 'script'],
      ['maps', 'map'],
      ['vehicles', 'vehicle'],
      ['cars', 'car'],
      ['clothes', 'clothing'],
      ['bundles', 'bundle'],
      ['creator stores', 'creator']
    ]);

    const normalizedNeedle = (value) => {
      const normalized = normalize(value);
      return aliases.get(normalized) || normalized;
    };

    const cardMatchesValue = (card, group, value) => {
      const dataKey = `lab${group.charAt(0).toUpperCase()}${group.slice(1)}`;
      const needle = normalizedNeedle(value);
      if (group === 'collection') {
        return String(card.dataset[dataKey] || '')
          .split('|')
          .some((handle) => normalize(handle) === normalize(value));
      }
      const haystack = normalize(card.dataset[dataKey]);
      if (group === 'availability') return haystack === needle;
      return haystack.includes(needle);
    };

    const countCategoryCards = (value, group = 'type') => {
      const normalized = normalizedNeedle(value);
      if (normalized === 'all' || normalized === 'all resources') return cards.length;
      if (normalized === 'free') {
        return cards.filter((card) => Number(card.dataset.labPriceCents || 0) === 0).length;
      }
      return cards.filter((card) => cardMatchesValue(card, group, value)).length;
    };

    const updateDerivedCounts = () => {
      categoryLinks.forEach((link) => {
        const countElement = link.querySelector('[data-lab-category-count]');
        if (!countElement || countElement.dataset.serverAuthoritative === 'true') return;
        countElement.textContent = String(countCategoryCards(
          link.dataset.labCategoryValue,
          link.dataset.labCategoryGroup || 'type'
        ));
      });

      frameworkLinks.forEach((link) => {
        const countElement = link.querySelector('[data-lab-framework-count]');
        if (!countElement || Number(countElement.dataset.serverCount || 0) > 0) return;
        const count = cards.filter((card) => cardMatchesValue(card, 'framework', link.dataset.labFrameworkCard)).length;
        countElement.textContent = String(count);
      });
    };

    const updateFilterButtonCounts = () => {
      filterButtons.forEach((button) => {
        const countElement = button.querySelector('small');
        if (!countElement) return;
        const serverCount = Number(button.dataset.serverCount || 0);
        const loadedCount = cards.filter((card) => cardMatchesValue(card, button.dataset.filterGroup, button.dataset.filterValue)).length;
        const serverIsAuthoritative = button.dataset.serverAuthoritative === 'true';
        countElement.textContent = String(serverIsAuthoritative ? serverCount : loadedCount);
      });
    };

    const updatePriceFill = () => {
      if (!minimumRange || !maximumRange || !priceFill) return;
      const ceiling = Number(maximumRange.max) || 1;
      const start = Math.max(0, Math.min(100, (Number(minimumRange.value) / ceiling) * 100));
      const end = Math.max(start, Math.min(100, (Number(maximumRange.value) / ceiling) * 100));
      priceFill.style.left = `${start}%`;
      priceFill.style.right = `${100 - end}%`;
    };

    const syncRangeToFields = (changedRange) => {
      if (!minimumRange || !maximumRange) return;
      if (Number(minimumRange.value) > Number(maximumRange.value)) {
        if (changedRange === minimumRange) maximumRange.value = minimumRange.value;
        else minimumRange.value = maximumRange.value;
      }
      const ceiling = Number(maximumRange.max) || 0;
      if (minimumInput) minimumInput.value = Number(minimumRange.value) > 0 ? minimumRange.value : '';
      if (maximumInput) maximumInput.value = Number(maximumRange.value) < ceiling ? maximumRange.value : '';
      updatePriceFill();
      applyFilters();
    };

    const syncFieldsToRange = () => {
      if (!minimumRange || !maximumRange) return;
      const ceiling = Number(maximumRange.max) || 0;
      const minimum = minimumInput?.value === '' ? 0 : Number(minimumInput.value);
      const maximum = maximumInput?.value === '' ? ceiling : Number(maximumInput.value);
      minimumRange.value = String(Math.max(0, Math.min(ceiling, minimum)));
      maximumRange.value = String(Math.max(Number(minimumRange.value), Math.min(ceiling, maximum)));
      updatePriceFill();
    };

    const applyFilters = () => {
      const selectedByGroup = new Map();
      filterButtons.forEach((button) => {
        if (!button.classList.contains('is-active')) return;
        const group = button.dataset.filterGroup;
        const values = selectedByGroup.get(group) || [];
        values.push(normalizedNeedle(button.dataset.filterValue));
        selectedByGroup.set(group, values);
      });

      const minimum = minimumInput?.value === '' ? null : Number(minimumInput.value) * 100;
      const maximum = maximumInput?.value === '' ? null : Number(maximumInput.value) * 100;
      let visible = 0;

      cards.forEach((card) => {
        const matchesGroups = [...selectedByGroup.entries()].every(([group, values]) => {
          return values.some((value) => cardMatchesValue(card, group, value));
        });
        const price = Number(card.dataset.labPriceCents || 0);
        const matchesMinimum = minimum === null || Number.isNaN(minimum) || price >= minimum;
        const matchesMaximum = maximum === null || Number.isNaN(maximum) || price <= maximum;
        const matches = matchesGroups && matchesMinimum && matchesMaximum;

        card.hidden = !matches;
        if (matches) visible += 1;
      });

      const hasFilters = selectedByGroup.size > 0 || minimum !== null || maximum !== null;
      if (countLabel) {
        countLabel.textContent = hasFilters
          ? `${visible} matching resources shown`
          : `Showing ${visible} on this page`;
      }
      if (emptyState) emptyState.hidden = visible !== 0;
    };

    const sortCards = () => {
      const mode = sortSelect?.value || 'manual';
      const sorted = [...cards].sort((left, right) => {
        if (mode === 'price-ascending') {
          return Number(left.dataset.labPriceCents || 0) - Number(right.dataset.labPriceCents || 0);
        }
        if (mode === 'price-descending') {
          return Number(right.dataset.labPriceCents || 0) - Number(left.dataset.labPriceCents || 0);
        }
        if (mode === 'created-descending') {
          return Number(right.dataset.labCreated || 0) - Number(left.dataset.labCreated || 0);
        }
        return originalOrder.get(left) - originalOrder.get(right);
      });
      sorted.forEach((card) => grid.append(card));
    };

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const active = button.classList.toggle('is-active');
        button.setAttribute('aria-pressed', String(active));
        applyFilters();
      });
    });

    priceForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      syncFieldsToRange();
      applyFilters();
    });

    minimumRange?.addEventListener('input', () => syncRangeToFields(minimumRange));
    maximumRange?.addEventListener('input', () => syncRangeToFields(maximumRange));
    minimumInput?.addEventListener('input', syncFieldsToRange);
    maximumInput?.addEventListener('input', syncFieldsToRange);

    resetButton?.addEventListener('click', () => {
      filterButtons.forEach((button) => {
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
      });
      if (minimumInput) minimumInput.value = '';
      if (maximumInput) maximumInput.value = '';
      if (minimumRange) minimumRange.value = minimumRange.min;
      if (maximumRange) maximumRange.value = maximumRange.max;
      updatePriceFill();
      if (sortSelect) sortSelect.value = 'manual';
      sortCards();
      applyFilters();
    });

    sortSelect?.addEventListener('change', sortCards);
    const loadNextCatalogPage = async (navigateOnError = true) => {
      if (!loadMoreButton || loadMoreButton.getAttribute('aria-busy') === 'true') return false;

      const nextUrl = loadMoreButton.href;
      const originalLabel = loadMoreButton.textContent;
      loadMoreButton.setAttribute('aria-busy', 'true');
      loadMoreButton.textContent = 'Loading resources...';

      try {
        const response = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error(`Catalog request failed with ${response.status}`);

        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = documentFragment.querySelector('[data-lab-home-grid]');
        if (!nextGrid) throw new Error('Catalog grid is missing from the next page');

        const nextCards = [...nextGrid.querySelectorAll('[data-lab-resource-card]')];
        nextCards.forEach((card) => {
          originalOrder.set(card, originalOrder.size);
          grid.append(card);
        });
        cards = [...cards, ...nextCards];
        updateSavedButtons(grid);
        updateDerivedCounts();
        updateFilterButtonCounts();
        sortCards();
        applyFilters();

        const followingPage = documentFragment.querySelector('[data-lab-home-load-more]');
        if (followingPage) {
          loadMoreButton.href = new URL(followingPage.getAttribute('href'), nextUrl).toString();
          loadMoreButton.removeAttribute('aria-busy');
          loadMoreButton.textContent = originalLabel;
        } else {
          loadMoreButton.closest('.lab-home-load-more-row')?.remove();
          loadMoreButton = null;
        }
        return true;
      } catch (error) {
        console.error(error);
        if (navigateOnError) {
          window.location.assign(nextUrl);
        } else if (loadMoreButton) {
          loadMoreButton.removeAttribute('aria-busy');
          loadMoreButton.textContent = originalLabel;
        }
        return false;
      }
    };

    loadMoreButton?.addEventListener('click', async (event) => {
      event.preventDefault();
      await loadNextCatalogPage();
    });
    updateDerivedCounts();
    updateFilterButtonCounts();
    updatePriceFill();
    applyFilters();

    const totalCount = Number(grid.dataset.labHomeTotalCount || cards.length);
    if (loadMoreButton && totalCount <= 200) {
      window.setTimeout(async () => {
        while (loadMoreButton) {
          const loaded = await loadNextCatalogPage(false);
          if (!loaded) break;
        }
      }, 0);
    }
  });

  const saved = new Set(JSON.parse(localStorage.getItem('labSavedResources') || '[]'));
  const updateSavedButtons = (scope = document) => {
    scope.querySelectorAll('[data-lab-save]').forEach((button) => {
      button.classList.toggle('is-saved', saved.has(button.getAttribute('data-lab-save')));
    });
  };
  updateSavedButtons();

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-lab-save]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    const handle = button.getAttribute('data-lab-save');

    if (saved.has(handle)) saved.delete(handle);
    else saved.add(handle);

    updateSavedButtons();
    localStorage.setItem('labSavedResources', JSON.stringify([...saved]));
  });

  const activateSideTab = (tab, moveFocus = false) => {
    const tabList = tab.closest('[data-lab-side-tabs]');
    const widget = tabList?.closest('.lab-side-list--tabs');
    if (!tabList || !widget) return;

    const tabName = tab.dataset.labSideTab;
    const tabs = [...tabList.querySelectorAll('[data-lab-side-tab]')];
    const panels = [...widget.querySelectorAll('[data-lab-side-panel]')];

    tabs.forEach((item) => {
      const selected = item === tab;
      item.classList.toggle('is-active', selected);
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
    });
    panels.forEach((panel) => {
      panel.hidden = panel.dataset.labSidePanel !== tabName;
    });

    if (moveFocus) tab.focus();
  };

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-lab-side-tab]');
    if (tab) activateSideTab(tab);
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('[data-lab-side-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

    const tabs = [...tab.closest('[data-lab-side-tabs]').querySelectorAll('[data-lab-side-tab]')];
    const currentIndex = tabs.indexOf(tab);
    let nextIndex = currentIndex;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = tabs.length - 1;

    event.preventDefault();
    activateSideTab(tabs[nextIndex], true);
  });

  const initSlider = (slider) => {
    if (slider.dataset.labSliderReady === 'true') return;

    const slides = [...slider.querySelectorAll('[data-lab-slide]')];
    const dots = [...slider.querySelectorAll('[data-lab-slide-dot]')];
    const previous = slider.querySelector('[data-lab-slider-prev]');
    const next = slider.querySelector('[data-lab-slider-next]');
    if (slides.length < 2) return;

    slider.dataset.labSliderReady = 'true';
    const autoplay = slider.dataset.labSliderEnabled !== 'false';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const interval = Math.max(4000, Number(slider.dataset.labSliderAutoplay) || 6000);
    let active = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer;
    let transitionTimer;
    let pointerStart = null;

    const show = (index, immediate = false) => {
      const nextIndex = (index + slides.length) % slides.length;
      const previousIndex = active;
      const forwardDistance = (nextIndex - previousIndex + slides.length) % slides.length;
      const leavingClass = forwardDistance > slides.length / 2
        ? 'is-leaving-right'
        : 'is-leaving-left';

      if (!immediate && nextIndex === previousIndex) return;
      if (transitionTimer) window.clearTimeout(transitionTimer);

      slides.forEach((slide, slideIndex) => {
        const selected = slideIndex === nextIndex;
        slide.classList.remove('is-leaving-left', 'is-leaving-right');
        if (!immediate && slideIndex === previousIndex) slide.classList.add(leavingClass);
        slide.classList.toggle('is-active', selected);
        slide.hidden = false;
        slide.setAttribute('aria-hidden', String(!selected));
      });

      active = nextIndex;
      dots.forEach((dot, dotIndex) => {
        const selected = dotIndex === active;
        dot.classList.toggle('is-active', selected);
        if (selected) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });

      if (!immediate) {
        transitionTimer = window.setTimeout(() => {
          slides.forEach((slide) => slide.classList.remove('is-leaving-left', 'is-leaving-right'));
        }, 850);
      }
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = undefined;
    };

    const start = () => {
      stop();
      if (!autoplay || reduceMotion || document.hidden) return;
      timer = window.setInterval(() => show(active + 1), interval);
    };

    const move = (index) => {
      show(index);
      start();
    };

    slider.__labSliderShow = move;
    previous?.addEventListener('click', () => move(active - 1));
    next?.addEventListener('click', () => move(active + 1));
    dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => move(dotIndex)));

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', (event) => {
      if (!slider.contains(event.relatedTarget)) start();
    });
    slider.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') move(active - 1);
      if (event.key === 'ArrowRight') move(active + 1);
    });
    slider.addEventListener('pointerdown', (event) => {
      pointerStart = event.clientX;
    });
    slider.addEventListener('pointerup', (event) => {
      if (pointerStart === null) return;
      const distance = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(distance) < 48) return;
      move(active + (distance < 0 ? 1 : -1));
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    show(active, true);
    start();
  };

  document.querySelectorAll('[data-lab-slider]').forEach(initSlider);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-lab-slider]').forEach(initSlider);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest('[data-lab-slide]');
    const slider = slide?.closest('[data-lab-slider]');
    if (!slide || !slider || typeof slider.__labSliderShow !== 'function') return;
    slider.__labSliderShow(Number(slide.dataset.labSlideIndex) || 0);
  });
})();
